import Image from 'app/Components/Shared/Image/image';
import BusinessInvoicesContext from 'app/Components/Page/BusinessInvoicesPage/BusinessInvoicesContext';
import React, {memo, useContext} from 'react';

const BusinessInvoicesTimeout = () => {
  const [{timeout}, dispatch] = useContext(BusinessInvoicesContext);
  return !timeout ? null : (
    <div className='BusinessInvoicesTimeout'>
      <div className='BusinessInvoicesTimeout__container'>
        <Image className='BusinessInvoicesTimeout__close'
          src={require('./images/icons-x.svg')}
          onClick={() => dispatch({type: 'close-email'})} />

        <Image className='BusinessInvoicesTimeout__image' src={require('./images/icons-search-stop.svg')} />
        <div className='BusinessInvoicesTimeout__title'>סליחה, החיפוש הפסיק</div>
        <div className='BusinessInvoicesTimeout__subtitle'>החיפוש הפסיק ויש לצמצם אותו ולנסות מחדש</div>
        <button className='BusinessInvoicesTimeout__submit' onClick={() => dispatch({type: 'close-timeout'})}>
          טוב
        </button>
      </div>
    </div>
  );
};
export default memo(BusinessInvoicesTimeout);
